/**
 * A dry-bulk draft reopens in the dry-bulk form (DBVN-0005 G-3), any other dry-bulk row in its read-only view;
 * every other row keeps the nomination details page.
 */
export const getNominationRowPath = (row: {
  id?: string | number;
  rawNominationType?: string | null;
  rawStatus?: string | null;
}) => {
  if (row.rawNominationType !== "DRY_BULK")
    return `/vessel-nomination/nomination-details/${row.id}`;
  return row.rawStatus === "DRAFT"
    ? `/vessel-nomination/dry-bulk/add/${row.id}`
    : `/vessel-nomination/dry-bulk/${row.id}`;
};
